import styled from 'styled-components';

export const Container = styled.section<{ backgroundColor: string }>`
  background-color: ${({ theme, backgroundColor }) => theme.colors[backgroundColor ?? 'offWhite']};
`
export const SubContainer = styled.div`
  max-width: 1440px;
  margin: auto;
`;